import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import sharedMessages from '@atlassian/generative-ai-modal/utils/messages';
import { improveWriting } from '../../prebuilt/config-items-range/enhance/enhance';
import { Logo } from '../../ui/components/Logo/Logo';
import { createOpenAIModalCommand } from '../decoration/actions';
export var floatingToolbarAIButtonTestID = "ak-editor-ai-selection-toolbar-ai-button";
export var floatingToolbarAIDropdownTestIDPrefix = "ak-editor-ai-selection-toolbar-dropdown-";
import { messages } from './selection-toolbar-messages';
export var getAIExperienceButton = function getAIExperienceButton(_ref) {
  var intl = _ref.intl,
    rangeBaseGenerate = _ref.rangeBaseGenerate,
    hideTitle = _ref.hideTitle,
    aiGlobalOptIn = _ref.aiGlobalOptIn,
    title = _ref.title,
    tooltip = _ref.tooltip,
    triggeredFor = _ref.triggeredFor;
  var didMouseEnter = false;
  return _objectSpread(_objectSpread({
    type: 'button',
    showTitle: true,
    testId: floatingToolbarAIButtonTestID,
    icon: AtlassianIntelligenceIcon,
    iconFallback: Logo
  }, !hideTitle && {
    title: intl.formatMessage(title !== null && title !== void 0 ? title : messages.aiToolbarTitle)
  }), {}, {
    tooltipContent: intl.formatMessage(tooltip !== null && tooltip !== void 0 ? tooltip : sharedMessages.aiUniversalShortCallToAction),
    disabled: false,
    onMouseEnter: function onMouseEnter() {
      didMouseEnter = true;
      return false;
    },
    onClick: function onClick(state, dispatch, view) {
      var openAIModalCommand = createOpenAIModalCommand({
        state: state,
        configItem: rangeBaseGenerate,
        lastTriggeredFrom: 'floatingToolbar',
        // ED-18194 Added analytics for floating toolbar to determine
        // the % of users who click the button vs shift tab to it
        triggerMethod: !didMouseEnter ? 'keyboard' : 'click',
        aiGlobalOptIn: aiGlobalOptIn,
        //TODO: AI Button experiment cleanup - platform_editor_ai_ai_button_block_elements
        triggeredFor: triggeredFor
      });
      openAIModalCommand(state, dispatch);
      return false;
    }
  });
};
export var getImproveWritingAIButton = function getImproveWritingAIButton(_ref2) {
  var intl = _ref2.intl,
    hideTitle = _ref2.hideTitle,
    aiGlobalOptIn = _ref2.aiGlobalOptIn;
  var didMouseEnter = false;
  return _objectSpread(_objectSpread({
    type: 'button',
    showTitle: true,
    testId: "".concat(floatingToolbarAIButtonTestID, "-improve-writing"),
    icon: undefined
  }, !hideTitle && {
    title: intl.formatMessage(messages.improveWritingToolbarIconTitle)
  }), {}, {
    tooltipContent: intl.formatMessage(messages.improveWritingToolbarIconTooltip),
    disabled: false,
    onMouseEnter: function onMouseEnter() {
      didMouseEnter = true;
      return false;
    },
    onClick: function onClick(state, dispatch, view) {
      var openAIModalCommand = createOpenAIModalCommand({
        state: state,
        configItem: improveWriting,
        lastTriggeredFrom: 'floatingToolbar',
        triggerMethod: !didMouseEnter ? 'keyboard' : 'click',
        aiGlobalOptIn: aiGlobalOptIn
      });
      openAIModalCommand(state, dispatch);
      return false;
    }
  });
};
var mapSelectionToolbarDropdowns = function mapSelectionToolbarDropdowns(_ref3) {
  var selectionToolbarDropdowns = _ref3.selectionToolbarDropdowns,
    intl = _ref3.intl,
    aiGlobalOptIn = _ref3.aiGlobalOptIn;
  if (!selectionToolbarDropdowns) {
    return [];
  }
  return selectionToolbarDropdowns.map(function (dropdownConfig) {
    var title = intl.formatMessage(dropdownConfig.label);
    if (dropdownConfig !== null && dropdownConfig !== void 0 && dropdownConfig.beta) {
      title = "".concat(title, " (").concat(intl.formatMessage(sharedMessages.betaLabel), ")");
    }
    return {
      type: 'dropdown',
      testId: floatingToolbarAIDropdownTestIDPrefix + dropdownConfig.id,
      title: title,
      disabled: false,
      options: dropdownConfig.options.map(function (option, index) {
        return {
          title: intl.formatMessage(option.label),
          testId: "ak-editor-ai-selection-toolbar-".concat(dropdownConfig.id, "-button-").concat(index),
          onClick: function onClick(state, dispatch, view) {
            var openAIModalCommand = createOpenAIModalCommand({
              state: state,
              configItem: option.configItem,
              lastTriggeredFrom: 'floatingToolbarDropdown',
              // ED-18194 Added analytics for floating toolbar to determine
              // the % of users who click the button vs shift tab to it
              // triggerMethod: !didMouseEnter ? 'keyboard' : 'click',
              aiGlobalOptIn: aiGlobalOptIn
            });
            openAIModalCommand(state, dispatch);
            return false;
          }
        };
      })
    };
  });
};
export var getAIExperienceDropdowns = function getAIExperienceDropdowns(_ref4) {
  var _rangeConfig$getSelec;
  var intl = _ref4.intl,
    rangeConfig = _ref4.rangeConfig,
    aiGlobalOptIn = _ref4.aiGlobalOptIn;
  var selectionToolbarDropdowns = (_rangeConfig$getSelec = rangeConfig.getSelectionToolbarDropdowns) === null || _rangeConfig$getSelec === void 0 ? void 0 : _rangeConfig$getSelec.call(rangeConfig);
  var aiDropdowns = mapSelectionToolbarDropdowns({
    selectionToolbarDropdowns: selectionToolbarDropdowns,
    intl: intl,
    aiGlobalOptIn: aiGlobalOptIn
  });
  var separator = {
    type: 'separator'
  };
  var separatedAIDropdowns = aiDropdowns.reduce(function (acc, val) {
    return acc.concat(separator, val);
  }, []);
  return separatedAIDropdowns;
};